import { render } from "./SelectCommunity.view.vue?vue&type=template&id=5c6e10f8"
import script from "./SelectCommunity.view.vue?vue&type=script&lang=js"
export * from "./SelectCommunity.view.vue?vue&type=script&lang=js"

import "./SelectCommunity.view.vue?vue&type=style&index=0&id=5c6e10f8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__